<template>
  <div v-show="value" class="dialog">
    <transition name="dialog-bounce">
      <div class="content" v-if="action_info">
        <div class="close" @click="close_modal">
        </div>
        <div class="head">
          {{action_info.union_info_title}}
        </div>
        <input v-if="isNeedTel" v-model='v' type="number" :placeholder="action_info.u_info_tip" class="input"/>
        <input type="text" v-model='v' :placeholder="action_info.u_info_tip" class="input" v-else/>
        <div class="button" @click="submit">立即开通</div>
        <div class="ruler" v-if="action_info.union_info_ruler">
          <div>说明：</div>
          <div v-html="action_info.union_info_ruler"></div>
        </div>
      </div>
    </transition>


  </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';

  export default create({
    name: 'UnionInputModal',
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      action_info: Object
    },
    data() {
      return {
        v: ''
      }
    },
    mounted() {
      this.setDefaultValue();
    },
    methods: {
      handleAction(action, data) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action, data);
      },
      close_modal() {
        this.handleAction('cancel', 'close_modal')
      },
      submit() {
        const v = this.v;
        if (!v) {
          return;
        }
        if (this.v.length > 32) {
          window.$toast('长度太长啦~')
          return;
        }
        if(this.isNeedTel){
          if(this.v.length !== 11){
            window.$toast('请输入正确的手机号')
            return;
          }
        }
        this.handleAction('confirm', v);
      },
      setDefaultValue() {
        let defaultValue = '';
        if (this.isNeedTel) {
          defaultValue = window.$bus.user.mobile || '';
        }
        if (!this.v) {
          this.v = defaultValue;
        }
      },
    },
    computed: {
      isNeedTel() {
        if (!this.action_info || !this.action_info.u_info_tip) {
          return false
        }
        //通过placeholder中的“手机号”关键词来判定是否是填写手机号，如果是填写手机号，则默认填写用户的绑定手机。
        return this.action_info.u_info_tip.indexOf('手机号') >= 0 //如果
      }
    },
    watch: {
      value(val) {
        if (val) {
          this.setDefaultValue();
        }
      }
    }


  });
</script>


<style lang="stylus" scoped>
  @import "../../../../share/mixins.styl"

  .dialog
    center()
    position fixed !important

  .close
    position absolute
    top -.6rem
    right -0.4rem
    width .5rem
    height @width
    background url(//vipcdn.mgtv.com/upload3/201902/12/close.png) no-repeat
    background-size cover

  .content
    position relative
    background white
    width 6.5rem
    border-radius: .1rem;
    padding-bottom .3rem;
    .head
      height: 1.1rem;
      border-radius: .1rem .1rem 0 0;
      background-image: linear-gradient(0deg, #fb4a37 0%, #fd7b1d 100%);
      line-height @height
      color white
      font-size .36rem
      text-align center
    .input
      height .81rem
      line-height @height
      width 5.3rem
      outline none
      padding 0 .1rem
      border: solid 1px #6a6763;
      border-radius: .35rem
      margin .35rem auto
      display block
      text-align center
    .button
      display block;
      width: 5.53rem;
      height: .8rem;
      background-image: linear-gradient(0deg, #ff6b00 0%, #fd280e 100%);
      margin 0 auto .35rem
      border-radius .4rem
      color white
      font-size .32rem
      text-align center
      line-height @height
    .ruler
      width: 6rem;
      background-color: #ffe4da;
      border-radius: 0.1rem;
      margin 0 auto
      word-break break-all
      padding .2rem
      font-size .18rem
      div
        font-size .18rem
        color: #9e8882;

</style>



// WEBPACK FOOTER //
// src/components/Popups/UnionVip/InputModal/InputModal.vue